<template>
  <div class="column">
    <breadcrumbs></breadcrumbs>
    <title-block :title="'Project Gebruikers'" :callback="GetOrRefreshData"></title-block>
    <div class="tableSettings">
      <div class="field">
        <div class="label is-small">Zoeken:</div>
        <input class="input is-small" type="text" v-model="searchTerm" placeholder="Typ hier uw zoekopdracht..." />
      </div>
    </div>
    <div class="tableSettings">
      <div class="field">
        <div class="label is-small">Selecteer Organisatie:</div>
        <b-select v-model="organisationSelect" class="is-size-7">
          <option value="0">Alle</option>
          <option value="1">Atlas Techrin Internation</option>
          <option value="2">Andere</option>
        </b-select>

        <b-select v-model="perPage" class="is-size-7 float-right">
          <option value="5">5 per pagina</option>
          <option value="10">10 per pagina</option>
          <option value="15">15 per pagina</option>
          <option value="20">20 per pagina</option>
          <option value="0">alles</option>
        </b-select>
        <div class="label is-small float-right">Aantal items per pagina:</div>
      </div>
    </div>

    <b-table
      :data="filteredAccounts"
      default-sort-direction="asc"
      :loading="isLoading"
      default-sort="name"
      :paginated="perPage > 0"
      :per-page="perPage"
      @click="row => rowClicked(row)"
      @details-open="
        (row, index) => {
          selectedClaim = row.level
        }
      "
      :detailed="admin"
      :show-detail-icon="true"
    >
      <template>
        <b-table-column field="email" label="Email" sortable v-slot="props">{{ props.row.user.email }}</b-table-column>
        <b-table-column field="name" label="Naam" sortable v-slot="props">{{
          (props.row.user.firstName + ' ' + props.row.user.lastName) | capitalize
        }}</b-table-column>
        <b-table-column field="orga" label="Organisatie" sortable v-slot="props">{{
          props.row.user.organizations[0] | organisationFormated
        }}</b-table-column>
        <b-table-column field="rights" label="Rechten" sortable v-slot="props">
          <img class="row-icon" :src="getIcon(props.row.level)" />
          <span>{{ rights[props.row.level] + ' Rechten' }}</span>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props" v-if="admin">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <p>
                <strong>{{ 'Rechten aanpassen van ' + props.row.user.firstName }} {{ props.row.user.lastName }}</strong>
                <br />
                <br />
                <b-field>
                  <b-select placeholder="Rechten" v-model="selectedClaim">
                    <option value="0">Lees Rechten</option>
                    <option value="1">Bewerk Rechten</option>
                    <option value="2">Beheer Rechten</option>
                  </b-select>
                  <p class="control" @click="newClaim(props.row)">
                    <button class="button is-success">Sla Op</button>
                  </p>
                </b-field>

                <strong>{{
                  props.row.user.firstName + ' ' + props.row.user.lastName + ' van het project verwijderen'
                }}</strong>
                <br />
                <br />
                <a class="button is-danger" @click="deleteUser(props.row)">Verwijderen</a>
              </p>
            </div>
          </div>
        </article>
      </template>
    </b-table>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import { mapGetters } from 'vuex'
import projectService from '@/services/projectService'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'
import userService from '@/services/userService.js'
import Mixin from '@/mixins/mixin.js'
// import * as lees from '@/assets/lees.svg'
// import * as beheer from '@/assets/beheer.svg'

export default {
  components: {
    Breadcrumbs,
    TitleBlock
  },
  filters: {
    organisationFormated: function (value) {
      if (!value) return ''
      else if (value.identifier == 1) {
        return 'Atlas Techrin International'
      }
      return ''
    },
    mixins: [rmBtnMixin, Mixin],
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data() {
    return {
      accounts: [],
      perPage: '',
      rights: ['Lees', 'Bewerk', 'Beheer'],
      selectedClaim: '',
      organisationSelect: 0,
      searchTerm: '',
      admin: false
    }
  },
  computed: {
    ...mapGetters(['project', 'isLoading', 'user', 'adminClaim']),
    filteredAccounts: function () {
      if (this.searchTerm == '' || !this.searchTerm || !this.accounts) {
        return this.accounts
      }
      const st = this.searchTerm.toLowerCase()
      return this.accounts.filter(
        a =>
          a.user.firstName.toLowerCase().includes(st) ||
          a.user.lastName.toLowerCase().includes(st) ||
          a.user.email.toLowerCase().includes(st)
      )
    }
  },
  watch: {
    organisationSelect: async function (val) {
      if (val == 0) {
        this.GetOrRefreshData()
      } else if (val == 1) {
        await this.GetOrRefreshData()
        this.accounts = this.accounts.filter(e => {
          return e.user.organizations[0].identifier == val
        })
      } else {
        await this.GetOrRefreshData()
        this.accounts = this.accounts.filter(e => {
          return e.user.organizations[0].identifier == val
        })
      }
    }
  },
  mounted() {
    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows
    this.GetOrRefreshData()
  },
  methods: {
    async GetOrRefreshData() {
      await this.$store.dispatch('getBearerToken')
      this.checkAdmin()
      this.accounts = (await projectService.getUserClaimsProject(this.project.projectId)).data.claims
    },
    rowClicked(row) {},
    getIcon(level) {
      switch (level) {
        case 0:
          return '../../static/lees.svg'
          return 'glasses'
        case 1:
          return '../../static/bewerk.svg'
          return 'pen'
        case 2:
          return '../../static/beheer.svg'
          return 'user-cog'
      }
    },
    async deleteUser(row) {
      const res = await this.deleteAlert('Gebruiker')
      if (res == 'deleted') {
        userService.removeClaimUser(row.user.email, 'Project', row.projectId).then(() => {
          this.GetOrRefreshData()
        })
      }
    },
    async newClaim(row) {
      const targetLevel = this.claimsToStr(this.selectedClaim)
      const rechten = this.claimsFormEnglishToDutch(targetLevel)
      const item = {
        level: this.claimsToStr(row.level),
        scope: 'Project',
        identifier: row.projectId,
        name: this.project.name
      }
      const user = row.user
      await this.popup(rechten, user, item, targetLevel, true)
      this.GetOrRefreshData()
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.project.projectId)
      this.admin = bool
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/main.scss';
td {
  cursor: pointer;
}
.fixedwidth {
  width: 100px;
}
.row-icon {
  height: 24px;
  width: 24px;
}
.tableSettings {
  .field {
    padding: 4px;
    .label {
      display: inline-block;
      margin-bottom: 0px;
    }
    .input {
      margin-left: 1px;
      width: 200px;
      background-color: $white;
    }
    .button {
      font-size: 0.75rem;
      background-color: white;
    }
    .control {
      margin-left: 5px;
      display: inline-block;
      .select select {
        background-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/UsersProject.vue